import { render, staticRenderFns } from "./invoiceGlassDetailedSummary.vue?vue&type=template&id=60050929&"
import script from "./invoiceGlassDetailedSummary.vue?vue&type=script&lang=js&"
export * from "./invoiceGlassDetailedSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports